import { QueryKeys } from "@/constants/Query";
import axiosInstance from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";

export interface PinnedPatientsResponse {
  patientIds: string[];
  userIds: number[];
}

export const usePinnedPatients = () => {
  return useQuery({
    queryFn: async () => {
      const response = await axiosInstance.get<PinnedPatientsResponse>(
        "/new-api/async-messaging/pinned-patients",
      );

      return response.data;
    },
    queryKey: QueryKeys.Provider.AsyncMessageDashboard.PINS,
    enabled: true,
  });
};
